import Loadable from '../../components/loadable';

const ContactCreditBalance = Loadable({
  loader: () => import('../../pages/contacts/credit_balance'),
});

angular.module('gym').value('ContactCreditBalance', ContactCreditBalance);
